<template>
  <v-container fluid class="pa-6">
    <v-card class="modern-card" elevation="0">
      <v-card-title class="px-6 py-4 d-flex align-center">
        <v-icon left color="accent" class="mr-3">fas fa-users-gear</v-icon>
        <span class="text-h6 font-weight-bold primary--text">Mapeo de Vendedores Relbase</span>
        <v-spacer />
        <v-chip
          small outlined
          :color="mappedCount > 0 ? 'accent' : 'grey'"
          class="font-weight-medium"
        >
          {{ mappedCount }} / {{ sellers.length }} mapeados
        </v-chip>
      </v-card-title>

      <v-divider />

      <v-data-table
        :headers="headers"
        :items="sellers"
        :loading="loading"
        class="modern-table"
        :footer-props="{
          showFirstLastPage: true,
          itemsPerPageOptions: [10, 20, 50],
        }"
      >
        <template v-slot:top>
          <div class="px-6 py-4 border-bottom d-flex align-center bg-white">
            <v-text-field
              v-model="search"
              placeholder="Buscar vendedor..."
              prepend-inner-icon="fas fa-search"
              outlined dense hide-details="auto"
              clearable
              class="modern-search-field flex-grow-1"
              style="max-width: 400px;"
            />
          </div>
        </template>

        <template v-slot:item.full_name="{ item }">
          <div class="d-flex align-center">
            <v-avatar size="32" color="accent" class="mr-3">
              <span class="white--text text-caption font-weight-bold">
                {{ getInitials(item) }}
              </span>
            </v-avatar>
            <div>
              <div class="font-weight-medium primary--text">{{ item.first_name }} {{ item.last_name }}</div>
              <div class="text-caption grey--text">{{ item.email }}</div>
            </div>
          </div>
        </template>

        <template v-slot:item.relbase_seller_id="{ item }">
          <v-autocomplete
            v-model="item.relbase_seller_id"
            :items="relbaseSellers"
            item-text="name"
            item-value="relbase_id"
            placeholder="Seleccionar vendedor Relbase"
            outlined dense hide-details="auto"
            clearable
            :loading="savingId === item.id"
            @change="saveMapping(item)"
            class="my-1"
            style="max-width: 320px;"
          >
            <template v-slot:item="{ item: seller }">
              <v-list-item-content>
                <v-list-item-title>{{ seller.name }}</v-list-item-title>
                <v-list-item-subtitle class="text-caption">{{ seller.email }}</v-list-item-subtitle>
              </v-list-item-content>
            </template>
          </v-autocomplete>
        </template>

        <template v-slot:item.status="{ item }">
          <v-chip
            x-small
            :color="item.relbase_seller_id ? 'accent' : 'grey lighten-2'"
            :text-color="item.relbase_seller_id ? 'white' : 'grey darken-1'"
            class="font-weight-medium"
          >
            {{ item.relbase_seller_id ? 'Mapeado' : 'Sin mapear' }}
          </v-chip>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import { fetchSellers } from '@/api/auth'
import { fetchRelbaseSellers } from '@/api/relbase'
import axios from 'axios'
import notifications from '@/utils/notifications'

export default {
  name: 'SellerMapping',
  data() {
    return {
      loading: false,
      savingId: null,
      search: '',
      sellers: [],
      relbaseSellers: [],
    }
  },
  computed: {
    headers() {
      return [
        { text: 'Vendedor Local', value: 'full_name', sortable: true },
        { text: 'Vendedor Relbase', value: 'relbase_seller_id', sortable: false },
        { text: 'Estado', value: 'status', align: 'center', sortable: false, width: '120' },
      ]
    },
    mappedCount() {
      return this.sellers.filter(s => s.relbase_seller_id).length
    },
  },
  async mounted() {
    await this.loadData()
  },
  methods: {
    async loadData() {
      this.loading = true
      try {
        const [sellers, relbaseSellers] = await Promise.all([
          fetchSellers(),
          fetchRelbaseSellers(),
        ])
        this.sellers = sellers || []
        this.relbaseSellers = relbaseSellers || []
      } catch (e) {
        notifications.showError('Error al cargar datos de vendedores')
      } finally {
        this.loading = false
      }
    },
    async saveMapping(user) {
      this.savingId = user.id
      try {
        await axios.patch(`auth/users/${user.id}`, {
          relbase_seller_id: user.relbase_seller_id || null,
        })
        notifications.showSuccess('Mapeo actualizado correctamente')
      } catch (e) {
        notifications.showError('Error al guardar el mapeo')
      } finally {
        this.savingId = null
      }
    },
    getInitials(user) {
      const first = (user.first_name || '').charAt(0).toUpperCase()
      const last = (user.last_name || '').charAt(0).toUpperCase()
      return first + last || '?'
    },
  },
}
</script>
